import axiosIns from '@/libs/axios'
import toErrorResult from '@/store/helpers/errorResult'

const ROOT_URL = '/Admin/data/trashBin'
// İstek hatasında yükleniyor durumunu kapatır, ekranın gösterebileceği bir sonuç döner
const handleError = (commit, error) => {
  commit('SET_LOADING', false)
  return toErrorResult(error)
}
export default {
  namespaced: true,
  state: {
    loading: false,
    dataList: [],
    dataCounts: 0,
    filterParams: {
      sdate: null,
      edate: null,
      components: [],
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    filterParams(state) {
      return state.filterParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    RESET_FILTER_PARAMS(state) {
      state.filterParams = {
        sdate: null,
        edate: null,
        components: [],
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      commit('SET_DATA_LIST', [])
      const data = JSON.stringify(params)
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data || [])
          commit('SET_DATA_COUNTS', response.data.count || 0)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => {
          commit('SET_DATA_COUNTS', 0)
          return handleError(commit, error)
        })
    },
    removeData({ commit }, param) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { ids: param.ids, components: param.components })
        .then(response => {
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => handleError(commit, error))
    },
    recoveryData({ commit }, param) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/recoveryData`, param)
        .then(response => {
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => handleError(commit, error))
    },
  },
}
